import { createContext, useContext, useState, useEffect } from 'react';
import { translations, LANGUAGES } from '../i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to French
    const saved = localStorage.getItem('apora-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('apora-language', language);
    document.documentElement.lang = language;
  }, [language]);

  // Get translation function
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language] || translations['fr'];
    for (const k of keys) {
      value = value?.[k];
    }
    return value !== undefined ? value : key;
  };

  // Get testimonials for current language
  const getTestimonials = () => {
    return translations[language]?.testimonials || translations['fr'].testimonials;
  };

  const value = {
    language,
    setLanguage,
    t,
    getTestimonials,
    languages: LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
